import { render } from "./TableView.vue?vue&type=template&id=53728499"
import script from "./TableView.vue?vue&type=script&lang=js"
export * from "./TableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__